export default __webpack_public_path__ + "static/media/discussion.c8b29ccc.svg";